import api from '@/apis/bu/bUTransferAPI.js';
import Crud from '@/stores/crudBase';
import EventBusGlobal from '@/commons/eventBusGlobal';
import commonFn from '@/commons/commonFunction';

var crud = new Crud('bUTransfer', api);

const state = {
  ...crud.state,
  _config: {
    table: 'bu_transfer',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
  dataEnterPaymentContent: [],
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataForEnterPaymentContent(context, payload) {
    let res = await api.getDataForEnterPaymentContent(payload);
    if (res) {
      context.commit('setDataEnterPaymentContent', res);
    }
    return res;
  },
};
const mutations = {
  ...crud.mutations,

  /**
   * Ghi đè Cập nhật khi sửa bản ghi ghi sổ
   * lttuan1 9.8.2022
   */
  updateItemPosted(state, payload) {
    // refresh lại bảng badeposit
    EventBusGlobal.$emit('BADeposit/refresh');
    // thực thi hàm của base
    crud.mutations.updateItemPosted(state, payload);
  },
  /**
   * set giá trị dữ liệu bảng nhập nội dung thanh toán trong form tham số in chứng từ 05TT
   * TTLONG 19.08.2022
   * @param {*} state
   */
  setDataEnterPaymentContent(state, payload) {
    state.dataEnterPaymentContent = payload;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
